{
	"logo": "Logo",
	"fileUpload": "Click or drag here to attach",
	"noInformation": "No informations",
	"toggleProducts": "No, just this product",
	"comingSoon": "Coming soon"
}
